<template>
  <v-container fluid class="form-section">
    <v-row>
      <v-col md="6">
        <div class="login-form-img"></div>
      </v-col>

      <v-col md="6" xl="4" class="">
        <div class>
          <div class="card">
            <div class="card-body">
              <div class="row">
                <div class="col-md-12 text-center" style="padding:0">
                  <div class="logo">
                    <a href="#">
                      <!-- <v-img src="../assets/logo.png" contain max-width="280px"></v-img> -->
                      <img src="../assets/logo.png" alt="Logo" class="img-fluid" />
                    </a>
                  </div>
                </div>
              </div>
              <!-- row -->

              <div class="row">
                <div class="col-lg-12 text-center" style="padding:0">
                  <p style="margin:0" class="text-content">To reset password please fill out the following fields.</p>
                </div>
              </div>
              <v-form @submit.prevent="login">
                <div class="row">
                  <div class="col-sm-12">
                    <div class="row">
                      <div class="col-md-12">
                        <!-- <div class="form-group"> -->
                        <v-text-field autocomplete="username" v-model="data.username"
                          class="pb-0 slide-x-transition-enter-active" outlined prepend-inner-icon="mdi-account"
                          label="Username" :error-messages="errors.username"></v-text-field>
                        <!-- <label for=""></label> -->
                        <!-- </div> -->
                      </div>
                    </div>

                    <div class="row">
                      <div class="col-md-12">
                        <!-- <div class="form-group"> -->
                        <v-text-field autocomplete="current-password" v-model="data.email" outlined
                          prepend-inner-icon="mdi-lock" label="Email" type="Email" :error-messages="errors.password">
                        </v-text-field>
                        <!-- </div> -->
                      </div>
                    </div>
                  </div>
                </div>

                <!-- <div class="row">
                  <div class="col-6">
                    <div class="form-group">
                      <v-checkbox v-model="checkbox" label="Remember Me"></v-checkbox>
                    </div>
                  </div>
                  <div class="col-6 text-right">
                    <div class="form-group">
                       <router-link 
          class="profile-link"
          active-class="active"
          :exact="true"
          to="reset/password"
        >
              <p>Forgot your password?</p>
                   </router-link>
                    </div>
                  </div>
                </div> -->
                <v-btn :loading="loading" type="btn" color="primary" @keyup.enter.prevent="login" block>Send Reset
                  Password Link</v-btn>
              </v-form>
            </div>
          </div>
          <!-- card -->
          <!-- 
          <div class="row">
            <div class="col-12 text-center">
              <p class="custom-link-text">
                <span>Or</span>
                <a
                  href="http://frontclass.newcityinteriors.com/"
                >Are you student? assessment form</a>
              </p>
            </div>
          </div> -->
        </div>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
export default {
  name: "Login",
  data() {
    return {
      loading: true,
      checkbox: "",
      data: {
        username: "",
        password: "",
      },
      errors: {},
    };
  },
  methods: {
    login() {
      this.loading = true;
      // axios
      //   .get(process.env.VUE_APP_BASE_URL + "sanctum/csrf-cookie")
      //   .then((response) => {
      //     console.log(response);
      //   });
      axios
        .get("password/reset/email", {
          params: {
            'data': this.data
          }
        })
        .then((response) => {
          this.loading = false;
          Toast.fire({
            icon: 'success',
            title: 'Email Sent Successfully!!',
          })
          // alert(response)
          // if (response.data.auth_token) {
          //   localStorage.setItem("auth_token", response.data.auth_token);
          //   localStorage.setItem("user", JSON.stringify(response.data.user));
          //   this.$store.dispatch("authUser", response.data).then((_) => {
          //     this.loading = false;
          //     this.$router.replace({ name: "Panel" });
          //   });
          // }
          // axios.get(apiRoutes.auth.user.url, {}).then(response => {

          // })
          // this.$router.push({name: ""})
        })
        .catch((error) => {
          this.loading = false;

          // console.log(error.response.data.message[0])
          if (error.response.status == 404) {
            // alert('Invalid Credentials')
            swal(error.response.data.message[0]);


          }
          //   // alert('invalid credes')
          // }
          if (error.response.status == 422) {
            this.errors = error.response.data.errors;
          }
        });
    },
  },
  beforeEnter: (to, from, next) => {
    // console.log(to, from);
    const token = localStorage.getItem("auth_token");
    // console.log(token);
    if (token) {
      next({ name: "Panel" });
    } else {
      next();
    }
  },
  mounted() {
    const token = localStorage.getItem("auth_token");
    // console.log("token");
    this.loading = false;
  },
};
</script>

<style lang="scss">
.v-application {
  background: #fff !important;
}

.form-section {
  background: #f8f8f8;
  margin-top: 0px;
}

.form-section .heading {
  font-size: 22px;
  font-weight: 500;
  color: #172b4d;
}

.form-section .sub-heading {
  font-size: 15px;
  font-weight: 400;
  color: #172b4d;
}

.card {
  background: #fafafa;
  box-shadow: 0px 3px 17px #2c28281c;
  border-radius: 10px;
  padding: 20px;
}

.card label {
  font-size: 16px;
  font-weight: 500;
  color: #172b4d;
}

.card .form-heading {
  font-size: 20px;
  font-weight: 600;
  color: #9333bb;
}

.form-section .logo {
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
}

.form-section .input-theme {
  background: #ffffff 0% 0% no-repeat padding-box;
  box-shadow: 0px 2px 4px #1717172e;
  /* border: 1px solid #3f475d4d; */
  /* border-radius: 5px; */
  opacity: 0.8;
  padding: 4px;
  margin-bottom: 30px;
}

.form-section .input-group-text {
  background: #ffffff 0% 0% no-repeat padding-box;
  box-shadow: 0px 2px 4px #1717172e;
  opacity: 0.8;
}

.form-section button.btn {
  font-size: 18px;
  color: #ffffff;
  background: #9459ae;
  border: 2px solid #9459ae;
  border-radius: 4px;
}

.form-section button.btn:hover {
  border: 4px solid #6a158e;
}

.divider {
  border-bottom: 1px solid #c3cbd3;
  margin-left: -19px;
  margin-right: -19px;
  margin-bottom: 20px;
}

.login-form-img {
  background: url("../assets/login-bg.png");
  min-height: 568px;
  background-repeat: no-repeat;
  background-size: cover;
  background-position: center;
  background-attachment: fixed;
}

p.text-content {
  font-size: 15px;
  font-weight: 600;
  color: #172b4d;
  margin-top: 25px;
}

.custom-label {
  font-size: 13px !important;
  font-weight: 600 !important;
  color: #57657d !important;
}

.input-container {
  display: -ms-flexbox;
  /* IE10 */
  display: flex;
  width: 100%;
  margin-bottom: 15px;
}

.icon {
  padding: 10px;
  background: #fff;
  color: #172b4d;
  min-width: 50px;
  text-align: center;
  font-size: 18px;
}

.input-field {
  width: 100%;
  padding: 10px;
  outline: none;
  border: none;
  padding-left: 5px;
}

.flex-div-container {
  position: absolute;
  width: 100%;
  top: 50%;
  transform: translateY(-50%);
}

.input-container:focus {
  border: 2px solid dodgerblue;
}

.custom-link-text {
  margin-top: 5px;
}

.custom-link-text * {
  font-size: 13px;
  font-weight: 500;
  color: #8e4faa !important;
}

.custom-link-text span {
  display: block;
}

@media only screen and (min-width: 768px) {
  .login-form-img {
    background-position-x: -300px;
    height: 100%;
  }
}

.iradio_flat-blue {
  margin-right: 6px;
}
</style>